module.exports = __webpack_public_path__ + "img/flg_fightlandtkn.13fc502.png";